module.exports = __webpack_public_path__ + "images/image_sound_on_5a9b90ca66e674878d09b9bd6590bed9.svg";